import Vue from 'vue'
import { productCategoryName } from '@/products/utils/product-categories'

Vue.filter('productCategoryName', productCategoryName)
